// extracted by mini-css-extract-plugin
var _1 = "ProfileInfoWidgetRows-moduledivider__sD5Vm Divider-moduleDivider__dL3Vg";
export { _1 as "divider" }
